import { PandaboardApiInstance } from "helpers/api";
import { ANALYTICS_COOKIE_NAME, getCookie, useAnalyticId } from "helpers/HotjarContext";
import { FormAddDocumentRequestDelete, FormAddDocumentRequestPut, IFinancialForm } from "models/financialForm/interfaces/financialForm.interface";
import { useContext } from "react";

export const getFinancialForm = async (id: string): Promise<IFinancialForm> =>{
  return PandaboardApiInstance
    .get(`financial-form/${id}`, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
};

export const fetchUpdateFinancialForm = async (formId: string, payload: any) =>
{
  const id = getCookie(ANALYTICS_COOKIE_NAME);

  return PandaboardApiInstance
    .put(`financial-form/WP/${formId}`, {...payload, analyticsIds: [id]}, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
};

export const fetchFormCrediticioAddDocument = async ({
  formId,
  formData,
  documentName,
}: FormAddDocumentRequestPut) =>
  PandaboardApiInstance.put(
    `financial-form/${formId}/documentWP/${documentName}`,
    formData,
    {
      requireAuth: true,
    }
  )
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchFormTaxSituationAddDocument = async ({
  formId,
  formData,
}: Omit<FormAddDocumentRequestPut, "documentName">): Promise<IFinancialForm> =>
  PandaboardApiInstance.put(
    `financial-form/wp/${formId}/tax-situation`,
    formData,
    {
      requireAuth: true,
    }
  )
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchDeleteFormCrediticioAddDocument = async ({
  formId,
  documentId,
}: FormAddDocumentRequestDelete) =>
  PandaboardApiInstance.delete(`financial-form/${formId}/documentWP/${documentId}`, {
    requireAuth: true,
  })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchUpdateCreditLineFinancialForm = async (formId: string, payload: any) =>
  PandaboardApiInstance
    .put(`financial-form/credit-line/WP/${formId}`, payload, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchFinancilFormAlertRetry = async (id: string) =>
  PandaboardApiInstance.post(
    `financial-form/${id}/alertRetry`,
    {},
    { requireAuth: true }
  )
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchNotifyValidateIdentity = async (
  formId: string,
  internalId?: string
) =>
  PandaboardApiInstance.post(
    "financial-form/WP/validate-identity",
    { formId, internalId },
    { requireAuth: true }
  )
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchFormsByOzoner = async (idOzoner: string) =>
  PandaboardApiInstance
    .get(`financial-form/ozoner/${idOzoner}`, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
